import { render, staticRenderFns } from "./ProductMaterialSelector.vue?vue&type=template&id=a40a9626&scoped=true"
import script from "./ProductMaterialSelector.vue?vue&type=script&lang=ts"
export * from "./ProductMaterialSelector.vue?vue&type=script&lang=ts"
import style0 from "./ProductMaterialSelector.vue?vue&type=style&index=0&id=a40a9626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40a9626",
  null
  
)

export default component.exports